export const USER_LIST_REQUEST = 'USER_LIST_REQUEST';
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS';
export const USER_LIST_FAILURE = 'USER_LIST_FAILURE';
export const USER_LIST_DISMISS = 'USER_LIST_DISMISS';



// WEBPACK FOOTER //
// ./src/js/actions/userListActionTypes.js